import { Grid } from '@mui/material';
import { ThemeProvider } from '../../styles/theme-config/ThemeProvider';
import NotificationBanner from './NotificationBanner';

/**
 * @name NotificationBannerContainer
 * @param {object} props -Strapi Data
 * @returns {HTMLElement} - Returns html content
 */
const NotificationBannerContainer = props => (
  <ThemeProvider palette={props?.cmsData?.notificationTheme?.theme}>
    <Grid container>
      <NotificationBanner cmsData={props?.cmsData} />
    </Grid>
  </ThemeProvider>
);
NotificationBannerContainer.displayName = 'NotificationBannerContainer';
export default NotificationBannerContainer;
